import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Cart } from './Cart';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  items: Cart[] = [];
  private readonly STORAGE_KEY = 'cart_items';
  constructor() {
    // Load cart from localStorage
    // if (typeof window !== 'undefined') {
    //   const stored = localStorage.getItem(this.STORAGE_KEY);
    //   if (stored) {
    //     this.items = JSON.parse(stored);
    //     this.cartItems.next(this.items); // ✅ broadcast loaded data
    //   }
    // }

    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      this.items = stored ? JSON.parse(stored) : [];
      this.ItemsList.next(this.items); // ✅ always broadcast, even if empty
    }

  }
  public ItemsList: BehaviorSubject<Cart[]> = new BehaviorSubject<Cart[]>([]);
  public isOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private updateStorage(): void {
    if (typeof window !== 'undefined') {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.items));
    }
    this.ItemsList.next(this.items); // 
  }

  add(cart: Cart): boolean {
  
    this.items.push(cart);
    this.ItemsList.next(this.items)
    this.updateStorage();
    return true
  }
  remove(index: number) {
    this.items.splice(index, 1)
    this.ItemsList.next(this.items)
    this.updateStorage();
    return this.items;
  }
  increaseQty(_cart: Cart): void {
    _cart.quantity++;
    this.qty_changed();
    this.updateStorage();
  }

  decreaseQty(_cart: Cart): void {
    _cart.quantity--;
    this.qty_changed();
    this.updateStorage();
  }

  qty_changed() {
    this.ItemsList.next(this.items)
    this.updateStorage();
  }
  emptyCart(): boolean {
    this.items = [];
    this.ItemsList.next(this.items)
    this.updateStorage();
    //return this.items;
    return true
  }

  cartItems() {
    return this.ItemsList.asObservable();
  }

  cartItemCount() {
    return this.ItemsList.value.length;
  }
  roundTo(num: number, places: number): number {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };

  OpenCart(_isOpen: any) {

    this.isOpen.next(_isOpen);
  }

  Get_Status_For_OpenCart(): Observable<boolean> {
    return this.isOpen.asObservable();
  }




  // Gross total before GST (Subtotal)
  GrossAmount(): number {
    return this.items.reduce((total, item) => total + item.unitPrice * item.quantity, 0);
  }

  // Total GST amount (calculated using gstAmount field)
  GSTAmount(): number {
    return this.items.reduce((total, item) => total + (Number(item.gstAmount) * item.quantity), 0);
  }

  // Final total (Subtotal + GST)
  NetAmount(): number {
    return this.GrossAmount() + this.GSTAmount()-this.DiscountAmount();
  }
  NetAmount_InPaise(): number {
    return Math.round(this.NetAmount() * 100);
  }


  // Final total DiscountAmount
  DiscountAmount(): number {
    return this.items.reduce((total, item) => {
      const originalPrice = item.unitPrice || 0;
      const discountPerItem =  item.discountAmount;
      return total + discountPerItem * item.quantity;
    }, 0);
  }

}
